<template>
  <div class="logo-horizontal">
    <img src="../../assets/img/zawaroom_h.svg" />
  </div>
</template>

<script>
export default {
  name: 'LogoHorizontal',
};
</script>

<style scoped lang="scss">
.logo-horizontal {
  &,
  img {
    width: 210px;
    height: 60px;
  }
}
</style>
